var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23383 4.47319H5.78302C6.4746 4.47319 6.82038 4.47319 7.08071 4.66082C7.34104 4.84846 7.45038 5.1765 7.66908 5.83258L8.20999 7.45531",
    stroke: "#222222",
    strokeWidth: 0.99404,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1504 17.3957H8.75761C8.61229 17.3957 8.53963 17.3957 8.48449 17.3895C7.90041 17.3241 7.50029 16.769 7.62295 16.1942C7.63453 16.14 7.6575 16.071 7.70346 15.9332V15.9332C7.75448 15.7801 7.77999 15.7036 7.80818 15.636C8.09673 14.9446 8.74952 14.4741 9.49674 14.419C9.56973 14.4136 9.6504 14.4136 9.81175 14.4136H15.1683",
    stroke: "#222222",
    strokeWidth: 0.99404,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8489 14.4136H11.8259C10.5543 14.4136 9.91845 14.4136 9.4205 14.0852C8.92254 13.7569 8.67209 13.1725 8.17118 12.0037L8.00336 11.6121C7.19869 9.73458 6.79636 8.7958 7.23832 8.12555C7.68027 7.45531 8.70164 7.45531 10.7444 7.45531H15.9937C18.2791 7.45531 19.4218 7.45531 19.8527 8.19796C20.2837 8.94062 19.7168 9.93274 18.5829 11.917L18.5829 11.917L18.3011 12.4102C17.7425 13.3877 17.4632 13.8765 17.0005 14.145C16.5377 14.4136 15.9747 14.4136 14.8489 14.4136Z",
    stroke: "#222222",
    strokeWidth: 0.99404,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6533,
    cy: 19.8808,
    r: 0.994041,
    fill: "#222222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.70101,
    cy: 19.8808,
    r: 0.994041,
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIco);
export default __webpack_public_path__ + "static/media/cart_ico.b805a66a5618a9bc1017bcfd7d1d75ff.svg";
export { ForwardRef as ReactComponent };